import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { cx } from '@emotion/css';
import * as css from './divider.module.less';
import { jsx as ___EmotionJSX } from "@emotion/react";
export function Divider(props) {
  var _props$draggableProps;

  return ___EmotionJSX("div", _extends({
    id: props.name,
    className: cx(props.className, css.divider),
    style: (_props$draggableProps = props.draggableProps) === null || _props$draggableProps === void 0 ? void 0 : _props$draggableProps.style
  }, process.env.ENV_RAW ? null : props.uiEvents), ___EmotionJSX("hr", {
    style: props.originalStyle || props.style
  }), props.children);
}